import React, { useState } from "react";
import pillupLogo from "../../../../assets/logo.png";
import { RouteConstants, ORDER_TRACKING_SHEET_ROLES } from "../../../../config/constants/route";
import { AiOutlineTable } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import "./sidebar.scss";
import { HiHome, HiUsers, HiClipboardList } from "react-icons/hi";

import { ROLES, TENANT_COMPANY_MAP } from "../../../../utils/constants";
import { getTenantId, getUserRoles } from "../../../../utils/helpers";
import { MdLocalOffer, MdLocalPhone, MdMedicalServices, MdDeliveryDining, MdUpcoming, MdOutlineSupportAgent, MdDocumentScanner, MdPayments, MdWarningAmber, MdShoppingCart, MdHandshake } from "react-icons/md";
import { TbActivityHeartbeat } from "react-icons/tb";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { FaRupeeSign } from "react-icons/fa";

function Sidebar() {
    const roles = getUserRoles();
    const tentantId = getTenantId();

    const [isCollapsed, setIsCollapsed] = useState(true);

    const navigations = [
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN) ? {
            name: "Home",
            icon: <HiHome style={{ fontSize: "22px" }} />,
            link: RouteConstants.HOME,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPPORT) || roles.includes(ROLES.SUPER_SUPPORT) ? {
            name: "Reorders",
            icon: <MdUpcoming style={{ fontSize: "22px" }} />,
            link: RouteConstants.FUTUREORDERS,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) ? {
            name: "Orders",
            icon: <AiOutlineTable style={{ fontSize: "22px" }} />,
            link: RouteConstants.ALLORDERS,
        } : null,
        ORDER_TRACKING_SHEET_ROLES.some((role) => roles.includes(role)) ? {
            name: "Tracking Sheet",
            icon: <HiClipboardList style={{ fontSize: "22px" }} />,
            link: RouteConstants.ORDER_TRACKING_SHEET,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.SUPPORT) ? {
            name: "Partner Orders",
            icon: <MdHandshake style={{ fontSize: "22px" }} />,
            link: RouteConstants.PARTNER_ORDERS,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.SUPPORT) ? {
            name: "Quotations",
            icon: <MdDocumentScanner style={{ fontSize: "22px" }} />,
            link: RouteConstants.QUOTATIONS,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.SUPPORT) ? {
            name: "Carts",
            icon: <MdShoppingCart style={{ fontSize: "22px" }} />,
            link: RouteConstants.CARTS,
        } : null,
        (tentantId === TENANT_COMPANY_MAP.PILLUP && (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.SUPPORT))) ? {
            name: "Payments",
            icon: <MdPayments style={{ fontSize: "22px" }} />,
            link: RouteConstants.PAYMENTS,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.SUPPORT) ? {
            name: "Users",
            icon: <HiUsers style={{ fontSize: "22px" }} />,
            link: RouteConstants.USERS,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) ? {
            name: "Medicines",
            icon: <MdMedicalServices style={{ fontSize: "22px" }} />,
            link: RouteConstants.Medicine_Master,
        } : null,
        (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPPORT) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.MARKETING)) ? {
            name: "Leads",
            icon: <MdLocalPhone style={{ fontSize: "22px" }} />,
            link: RouteConstants.REQUEST_CALLBACK,
        } : null,
        (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPPORT) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT)) ? {
            name: "Delivery",
            icon: <MdDeliveryDining style={{ fontSize: "22px" }} />,
            link: RouteConstants.DELIVERY,
        } : null,
        roles.includes(ROLES.ADMIN) || roles.includes(ROLES.MARKETING) || roles.includes(ROLES.SUPER_ADMIN) ? {
            name: "Marketing",
            icon: <MdLocalOffer style={{ fontSize: "22px" }} />,
            link: RouteConstants.MARKETING,
        } : null,
        (tentantId !== TENANT_COMPANY_MAP.EAZY && (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT))) ? {
            name: "Support",
            icon: <MdOutlineSupportAgent style={{ fontSize: "22px" }} />,
            link: RouteConstants.SUPPORT,
        } : null,
        (tentantId !== TENANT_COMPANY_MAP.EAZY && (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.SUPPORT))) ? {
            name: "Refunds",
            icon: <FaRupeeSign style={{ fontSize: "22px" }} />,
            link: RouteConstants.ALLREFUNDS,
        } : null,
        (tentantId === TENANT_COMPANY_MAP.PILLUP && (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPPORT) || roles.includes(ROLES.SUPER_SUPPORT))) ? {
            name: "Action Needed",
            icon: <MdWarningAmber style={{ fontSize: "22px" }} />,
            link: RouteConstants.ACTION_NEEDED,
        } : null,
        (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPPORT) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.PHARMACIST)) ? {
            name: "GLP-1",
            icon: <span style={{ fontSize: "13px", fontWeight: 700, letterSpacing: "0.5px" }}>GLP</span>,
            link: RouteConstants.GLP1_DASHBOARD,
        } : null,
        (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN) || roles.includes(ROLES.SUPPORT) || roles.includes(ROLES.SUPER_SUPPORT) || roles.includes(ROLES.PHARMACIST)) ? {
            name: "Self-Checkout",
            icon: <TbActivityHeartbeat style={{ fontSize: "22px" }} />,
            link: RouteConstants.SELF_CHECKOUT_DASHBOARD,
        } : null,
        (tentantId === TENANT_COMPANY_MAP.EAZY && (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.PHARMACIST) || roles.includes(ROLES.SUPER_ADMIN))) ? {
            name: "Reports",
            icon: <HiOutlineDocumentReport style={{ fontSize: "22px" }} />,
            link: RouteConstants.REPORTS,
        } : null,
        // The "New OPS console ↗" entry that used to sit here was removed: the
        // ConsoleSwitcher in the topbar (src/v2/components/ConsoleSwitcher.jsx) now
        // offers every console the user is entitled to, from one control that also
        // shows which one they are currently in. A sidebar link to the same
        // destination was a second, weaker way to do it.
    ];
    return (
        <div className={`sidebar-container sticky h-[100vh] flex flex-col transition-all duration-300 ${isCollapsed ? 'w-20' : 'w-64'}`}>
            {/* BRAND LOGO -- stays pinned; only the nav list below scrolls. */}
            <div className="flex shrink-0 items-center justify-between px-3 pt-5">
                <img src={pillupLogo} alt="Pillup Logo" className={`${isCollapsed ? 'w-12' : 'w-[70%]'}`} />
                <button
                    onClick={() => setIsCollapsed(!isCollapsed)}
                    className="p-0 rounded-lg hover:bg-gray-100"
                >
                    {isCollapsed ?
                        <HiChevronRight className="w-9 h-9" /> :
                        <HiChevronLeft className="w-9 h-9" />
                    }
                </button>
            </div>
            {/* NAVIGATION -- scrolls on its own when the entries outgrow the screen height. */}
            <div className="sidebar-scroll min-h-0 flex-1 overflow-y-auto overflow-x-hidden mt-10 pb-6">
                <div className="flex flex-col justify-start items-start gap-3 w-full">
                    {navigations.filter(nav => nav !== null).map((nav, index) => (
                        <NavLink
                            key={index}
                            style={{ width: "98%" }}
                            className={(data) => {
                                return data.isActive ? "navlink-item rounded-2xl shadow-soft-2xl w-100" : "navlink-item-active w-100";
                            }}
                            to={nav.link}>
                            <div
                                key={index}
                                className="flex items-center hover ? 'bg-[#158D7B]' : 'bg-[#158D7B]'">
                                <div className="text-xl">{nav.icon}</div>
                                {!isCollapsed && <div className="ml-4 font-sans navnames">{nav.name}</div>}
                            </div>
                        </NavLink>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
